import React from 'react';
import SEO from '../components/SEO';
import About from '../components/About-us';
import { organizationSchema, breadcrumbSchema } from '../utils/structuredData';
import './AboutPage.css';

const AboutPage = () => {
  const breadcrumbStructuredData = breadcrumbSchema([
    { name: 'Home', url: 'https://www.gettechupdate.com' },
    { name: 'About Us', url: 'https://www.gettechupdate.com/about' }
  ]);

  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [organizationSchema, breadcrumbStructuredData]
  };

  return (
    <>
      <SEO
        title="About Us | Tech Update - Your Trusted Technology Partner"
        description="Learn about Tech Update - a dynamic startup empowering businesses through innovative technology solutions. Expert team delivering beautiful, scalable, and user-friendly digital products."
        keywords="about tech update, technology company, software development company, startup solutions, digital transformation, web development company, mobile app development company"
        url="https://www.gettechupdate.com/about"
        structuredData={combinedSchema}
      />
      <div className="about-page">
        <About />
      </div>
    </>
  );
};

export default AboutPage;

